import { useState, useEffect, useMemo } from "react";

// Ein Ort für die Adresszeile.
//
// Warum überhaupt: history.pushState löst KEIN popstate aus - das feuert nur
// bei Zurück/Vorwärts im Browser. Wer also nach einem pushState mitbekommen
// will, dass sich der Pfad geändert hat, muss selbst benachrichtigt werden.
// Bisher wurde dafür an mehreren Stellen ein künstliches PopStateEvent
// abgefeuert; das funktionierte, war aber leicht zu vergessen.
const hoerer = new Set();

function benachrichtigen() {
  hoerer.forEach((f) => f());
}

// Navigiert ohne Neuladen. `ersetzen` schreibt den aktuellen Eintrag um,
// statt einen neuen anzulegen - sinnvoll, wenn ein Zwischenschritt nicht
// im Zurück-Verlauf landen soll.
export function navigate(pfad, { ersetzen = false } = {}) {
  const ziel = String(pfad || "/").startsWith("/") ? String(pfad) : `/${pfad}`;
  if (window.location.pathname === ziel) return;
  if (ersetzen) window.history.replaceState(null, "", ziel);
  else window.history.pushState(null, "", ziel);
  benachrichtigen();
}

// Liefert den aktuellen Pfad und rendert neu, wenn er sich ändert -
// egal ob durch navigate() oder durch Zurück/Vorwärts im Browser.
export function usePfad() {
  const [pfad, setPfad] = useState(() => window.location.pathname);
  useEffect(() => {
    const aktualisieren = () => setPfad(window.location.pathname);
    hoerer.add(aktualisieren);
    window.addEventListener("popstate", aktualisieren);
    // Zwischen Abonnieren und erstem Rendern kann sich der Pfad geändert
    // haben, etwa durch eine Weiterleitung beim Start.
    aktualisieren();
    return () => {
      hoerer.delete(aktualisieren);
      window.removeEventListener("popstate", aktualisieren);
    };
  }, []);
  return pfad;
}

// Die Pfadsegmente ohne leere Teile: "/careers/7/12" -> ["careers","7","12"]
export function useSegmente() {
  const pfad = usePfad();
  return useMemo(() => pfad.split("/").filter(Boolean), [pfad]);
}

export function segmenteVon(pfad) {
  return String(pfad || "").split("/").filter(Boolean);
}
